// Firebase Configuration
// Replace these placeholder values with your actual Firebase project credentials
// Get them from: Firebase Console > Project Settings > Your Apps > Config

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyBeEQOoGmNPUGWBr1sY23UyTtlbHe3_o7o",
    authDomain: "archaeo-hub.firebaseapp.com",
    projectId: "archaeo-hub",
    storageBucket: "archaeo-hub.firebasestorage.app",
    messagingSenderId: "141108488624",
    appId: "1:141108488624:web:25494542f7f61bcb8f0e75"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
